module.exports = __webpack_public_path__ + "img/out_office_mobile.e4177b22.jpg";